import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { COLORS } from '../Colors'

export type ItemMenuProps = {
    label: string
    icon: JSX.Element
    linkTo?: string
    onClick?: () => void | null
    isClickable?: boolean
    isVisible?: boolean
}

function ItemMenu({
    label,
    icon,
    linkTo,
    onClick,
    isClickable = true,
    isVisible = true,
}: ItemMenuProps): JSX.Element | null {
    const location = useLocation()
    const currentPath = location.pathname

    if (!isVisible) {
        return null
    }

    if (!linkTo) {
        return (
            <Item key={label} onClick={onClick} isClickable={isClickable}>
                {icon}
                <ItemLabel>{label}</ItemLabel>
            </Item>
        )
    }
    return (
        <Link to={linkTo} style={{ textDecoration: 'none' }}>
            <Item
                key={label}
                onClick={onClick}
                isClickable={isClickable}
                currentPath={currentPath}
                linkTo={linkTo}
            >
                {icon}
                <ItemLabel>{label}</ItemLabel>
            </Item>
        </Link>
    )
}

const Item = styled.div<{
    isClickable: boolean
    currentPath?: string
    linkTo?: string
}>`
    cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: Roboto;
    font-size: 14px;
    padding: 11px 15px;
    color: ${(props) =>
        props.currentPath === props.linkTo
            ? COLORS.primaryOrange
            : COLORS.brownishGrey};
    background-color: ${COLORS.primaryWhite};
    width: 100%;
    &:hover {
        background-color: ${(props) =>
            props.isClickable ? COLORS.veryLightPink : COLORS.primaryWhite};
    }
    &:active {
        color: ${(props) =>
            props.isClickable ? COLORS.primaryOrange : COLORS.brownishGrey};
    }
`

const ItemLabel = styled.span`
    margin-left: 17px;
`

export default ItemMenu
